import React from 'react';
import './NearbyAttractions.css';

// Importing all images
import aig_hospital from '../assets/aig_hospital.jpg';
import botanical_gardens from '../assets/botanical_gardens.jpg';
import durgam_cheruvu from '../assets/durgam_cheruvu.jpg';
import inorbit_mall from '../assets/inorbit_mall.jpg';
import shilparamam from '../assets/shilparamam.jpg';
import airport from '../assets/airport.jpg';

const attractions = [
  {
    id: 'aig-hospital',
    name: 'AIG Hospital',
    description: 'A world-class healthcare facility in the heart of Gachibowli.',
    image: aig_hospital,
  },
  {
    id: 'botanical-gardens',
    name: 'Hyderabad Botanical Gardens',
    description: 'A serene place to enjoy nature and unwind, just minutes away.',
    image: botanical_gardens,
  },
  {
    id: 'durgam-cheruvu',
    name: 'Durgam Cheruvu',
    description: 'Known as the "Secret Lake," perfect for boating and relaxation.',
    image: durgam_cheruvu,
  },
  {
    id: 'inorbit-mall',
    name: 'Inorbit Mall',
    description: 'A premier shopping and entertainment destination in Gachibowli.',
    image: inorbit_mall,
  },
  {
    id: 'shilparamam',
    name: 'Shilparamam',
    description: 'An arts and crafts village showcasing traditional art and culture.',
    image: shilparamam,
  },
  {
    id: 'airport',
    name: 'Rajiv Gandhi International Airport',
    description: 'The primary international airport serving Hyderabad is 27KM far.',
    image: airport,
  },
];

const NearbyAttractions = () => {
  return (
    <div id="attractions" className="nearby-attractions">
      <h2>Nearby Attractions in Gachibowli</h2>
      <div className="attractions-list">
        {attractions.map((attraction) => (
          <div key={attraction.id} className="attraction">
            <div className="image-container">
              <img
                src={attraction.image}
                alt={attraction.name}
                className="attraction-image"
              />
              <div className="attraction-overlay">
                <h3>{attraction.name}</h3>
                <p>{attraction.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NearbyAttractions;
